import { Injectable } from '@angular/core';
import {BehaviorSubject, Observable} from "rxjs";
import {ItemManagerService} from "../itemManager/item-manager.service";

@Injectable({
  providedIn: 'root'
})
export class PerspectiveService {

  private _currentPerspective: BehaviorSubject<string|number> = new BehaviorSubject<string|number>('');

  constructor(private itemManagerService: ItemManagerService) { }

  get currentPerspective(): Observable<string|number> {
    return this._currentPerspective.asObservable();
  }

  setCurrentPerspective(id: string|number) {
    var items = this.itemManagerService.getAllItems();
    for (let i in items) {
      if (items.hasOwnProperty(i)) {
        let item = items[i];
        if (id) {
          let tool = item.config.getTool();
          if (tool && tool.perspectives) {
            if (tool.perspectives.indexOf(id) >= 0) {
              item.setVisibility(true);
              continue;
            }
          }
          item.setVisibility(false);
        } else {
          item.setVisibility(true);
        }
      }
    }
    this._currentPerspective.next(id);
  }
}
